module.exports = __webpack_public_path__ + "static/media/7.934a5f23.png";